import { apiActionCreator } from '../helpers';
import { events } from '../../services/api';
import { EVENTS_SELECT } from '../../constants/actions';
import { selectedEventIdSelector } from '../../selectors/events/events';
import { push } from 'react-router-redux';
import { TIMETABLE_PATH } from '../../constants/routes';
import { eventsFetchedSelector, eventsFetchingSelector } from '../../selectors/events/events';

export function fetch() {
    return async (dispatch, getState) => {
        if (!(eventsFetchedSelector(getState()) || eventsFetchingSelector(getState()))) {
            dispatch({
                type: EVENTS_SELECT.FETCH_START
            });
            await apiActionCreator(dispatch, events.get, response => {
                dispatch({
                    type: EVENTS_SELECT.FETCH_OK,
                    ...response
                });
            });
        }
    };
}

export function forceFetchEvents() {
    return async dispatch => {
        dispatch({
            type: EVENTS_SELECT.FETCH_START
        });
        await apiActionCreator(dispatch, events.get, response => {
            dispatch({
                type: EVENTS_SELECT.FETCH_OK,
                ...response
            });
        });
    };
}

export function change(id) {
    return {
        type: EVENTS_SELECT.CHANGE,
        value: id
    };
}

export function select() {
    return (dispatch, getState) => {
        const selected = selectedEventIdSelector(getState());
        dispatch({
            type: EVENTS_SELECT.DONE
        });
        dispatch(push(TIMETABLE_PATH.replace(':id', selected)));
    };
}
